import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// Modal de alerta al entrar — indica cuántos chats siguen sin responder
export const MensajeriaModalAlerta = ({ total, onCerrar }) => {
    return (
        <div className="mjr-modal-overlay">
            <div className="mjr-modal-box">
                <div className="mjr-modal-icono">
                    <AccessTimeIcon />
                </div>
                <h3 className="mjr-modal-titulo">Clientes sin responder</h3>
                <p className="mjr-modal-texto">
                    <span className="mjr-modal-numero">{total}</span> chats respondieron y siguen sin atender
                </p>
                <button className="mjr-modal-btn" onClick={onCerrar}>
                    Ver mensajería
                </button>
            </div>
        </div>
    );
};
